import React, { Suspense } from 'react';
import { Route, Routes } from 'react-router-dom';
import { Layout } from './components/layout/Layout';
import { RoutedPageFallback } from './components/layout/RoutedPageFallback';
import { AICapabilitiesPage } from './pages/AICapabilitiesPage';
import { ComparisonPage } from './pages/ComparisonPage';
import { HomePage } from './pages/HomePage';
import { ModulesPage } from './pages/ModulesPage';
import { PricingPage } from './pages/PricingPage';
import { ProductRoutePage } from './pages/ProductRoutePage';
import {
  legacyProductMarketingRoutes,
  segmentMarketingRoutes,
  toReactRoutePath,
} from './config/marketingRoutes';

const LoginBridgePage = React.lazy(async () => {
  const module = await import('./pages/LoginBridgePage');
  return { default: module.LoginBridgePage };
});
const PrivacyPolicyPage = React.lazy(async () => {
  const module = await import('./pages/PrivacyPolicyPage');
  return { default: module.PrivacyPolicyPage };
});
const TermsOfServicePage = React.lazy(async () => {
  const module = await import('./pages/TermsOfServicePage');
  return { default: module.TermsOfServicePage };
});
const NotFoundPage = React.lazy(async () => {
  const module = await import('./pages/NotFoundPage');
  return { default: module.NotFoundPage };
});

export default function App(): React.JSX.Element {
  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route index element={<HomePage />} />
        <Route path="precios" element={<PricingPage />} />
        {legacyProductMarketingRoutes.map((route) => (
          <Route
            key={route.routeKey}
            path={toReactRoutePath(route.path)}
            element={<ProductRoutePage routeKey={route.routeKey} />}
          />
        ))}
        {segmentMarketingRoutes.map((route) => (
          <Route
            key={route.segmentCode}
            path={toReactRoutePath(route.path)}
            element={<ProductRoutePage segmentCode={route.segmentCode} />}
          />
        ))}
        <Route path="modulos" element={<ModulesPage />} />
        <Route path="ia" element={<AICapabilitiesPage />} />
        <Route path="comparar" element={<ComparisonPage />} />
        <Route path="privacy" element={<PrivacyPolicyPage />} />
        <Route path="terms" element={<TermsOfServicePage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Route>
      <Route
        path="/login"
        element={
          <Suspense fallback={<RoutedPageFallback />}>
            <LoginBridgePage />
          </Suspense>
        }
      />
    </Routes>
  );
}
